import { z } from "zod";
import { UpdateAppointmentRequest } from "../dtos/requests";

export const UpdateAppointmentRequestSchema: z.ZodType<UpdateAppointmentRequest> =
  z.object({
    status: z
      .enum([
        "aguardando",
        "agendado",
        "concluido",
        "cancelado",
        "recusado",
        "em andamento",
      ])
      .optional(),
    reason_for_cancellation: z.string().optional(),
    cancel_recurrency: z.boolean().optional(),
  });
